//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { gql } from 'graphql-tag'
import { Language, ContentType } from '@constants'

const DOSSIERS = gql`
  query ($where: DossierFilterInput) {
    dossiers(where: $where) {
      nodes {
        id
        imageUrl
        title
        slug
        externalId
      }
    }
  }
`

export default {
  name: 'DossierList',
  scrollToTop: true,
  data() {
    return {
      dossiers: [],
      showPlaceholder: true,
      placeholders: 8,
      ContentType,
      Language
    }
  },
  fetchOnServer: false,
  async fetch() {
    await this.refresh()
  },
  computed: {
    language() {
      return this.$store.get('language/locale') || 'en'
    },
    languageId() {
      return this.language === 'en' ? Language.ENGLISH : Language.DUTCH
    },
    currentBreakPoint() {
      return this.$store.get('app/currentBreakPoint') || 'md'
    }
  },
  watch: {
    languageId() {
      this.refresh()
    }
  },
  mounted() {
    this.setBreadcrumb({
      isShow: true,
      pageTitle: this.$t('dossier.dossiers')
    })
    this.setFilters({
      isShow: false,
      showFilterTotal: false,
      header: this.$t('dossier.dossiers'),
      isCardHeader: true
    })
  },
  methods: {
    async refresh() {
      this.showPlaceholder = true

      try {
        const { data } = await this.$apollo.query({
          query: DOSSIERS,
          variables: {
            where: {
              languageId: {
                eq: this.languageId
              }
            }
          }
        })

        this.dossiers = data.dossiers.nodes
      } catch (error) {
        this.handleError(error)
      } finally {
        this.showPlaceholder = false
      }
    }
  }
}
